import {Field, reduxForm} from 'redux-form/immutable';
import {FormattedMessage, injectIntl, intlShape} from 'react-intl';
import Button from '../../../ui/Button';
import Form from '../../../ui/Form';
import Bar from '../../../ui/Bar';
import Input from '../../../ui/Input';
import React, {Component} from 'react';
import PropTypes from 'prop-types';
import Alert from "../../../ui/Alert";

/* eslint-disable react/prop-types, react/no-multi-comp */
const renderField = allProps => {

    /* eslint no-unused-vars: ["off", { "ignoreRestSiblings": true }] */
    const {size, ...props} = allProps;

    props.input.id = (props.id || props.input.name);

    return (
        <Form.Control erroneous={!!props.error}>
            {props.input.label !== false && (
                <Form.Label htmlFor={props.input.name} required={props.required}>
                    <FormattedMessage id={props.label}/>
                </Form.Label>
            )}
            <Input {...props.input} type={props.type}/>
            {props.input.hint && (
                <Form.Hint>
                    <FormattedMessage id={props.input.hint}/>
                </Form.Hint>
            )}
            {props.touched && props.error && (
                <Form.Error>
                    {props.error}
                </Form.Error>
            )}
        </Form.Control>
    );
};

@injectIntl
class ConfirmForm extends Component {
    /* eslint-enable */
    static propTypes = {
        intl: intlShape,
        handleSubmit: PropTypes.func,
        submitting: PropTypes.bool,
    };

    componentWillMount() {
        const userId = this.props.userId;
        this.props.initialize({code: userId});
    }

    render() {
        const {handleSubmit} = this.props;

        return (
            <Form onSubmit={handleSubmit}>

                <Form.Fieldset>
                    <Alert key='deactivateProfile' type='deactivateProfile'>
                        <FormattedMessage
                            id='frontend.form_deactivate.text.deactivate_profile_hint'
                        />
                    </Alert>
                    <Form.Row>
                        <Field
                            name='email'
                            label='frontend.form_deactivate.label.email'
                            component={renderField}
                            type='email'
                            required
                        />
                    </Form.Row>
                </Form.Fieldset>
                <Bar>
                    <Button link to='/settings' block>
                        <FormattedMessage id='frontend.form_deactivate.button.cancel'/>
                    </Button>
                    <Button emphasis='primary' type='submit' block>
                        <FormattedMessage id='frontend.form_deactivate.button.confirm'/>
                    </Button>
                </Bar>
            </Form>
        );
    }
}

export const FormComponent = reduxForm({
    form: 'form_deactivate',
})(ConfirmForm);
